import * as PropTypes from 'prop-types'

const ConciliationShape = PropTypes.shape({

})

export { ConciliationShape }
